<template>
    <div class="d-flex min-vh-100 min-w-full justify-content-center align-items-center" id="register-bg">
        <div class="row d-flex justify-content-center">
            <div class="bg-body p-2 col-11 rounded shadow d-flex flex-column justify-content-center align-items-center">
                <div class="col-12 text-center">
                    <div>
                        <img style="max-height: 100px;" class="rounded rounded-50" src="@/assets/dressmaker2.jpg" />
                    </div>
                </div>
                <div class="col-12 text-center ff-handwrite fs-1 fs-bold">
                    <p>Dressmaker</p>
                </div>
                <div class="col-12 rounded">
                    <div class="card bg-body border-0 shadow">
                        <div class="text-center ff-l1 fs-2">Inscription</div>
                        <div class="card-body">
                            <RegisterForm />
                            <div class="text-center mt-3">
                                <small class="text-muted">Déjà inscrit ?
                                    <a role="button" class="text-primary" @click="$router.push({ name: 'login' })">Se connecter</a>
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RegisterForm from '@/components/forms/RegisterForm.vue';

export default {
    name: 'Register',
    components: {
        RegisterForm
    }
};
</script>